import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({
  authenticated,
  component: Component,
  render,
  authenticationPage = '/login',
  path,
  ...rest
}) => {
  // console.log('Protected Route: authenticated, path= ', path);
  return (
    <Route
      {...rest}
      path={path}
      render={(props) => {
        if (authenticated) {
          if (Component) {
            console.log(`ProtectedRoute (${path}): Auth passed, rendering component`);
            return <Component {...props} />;
          } else {
            console.log(`ProtectedRoute (${path}): Auth passed, rendering component with function`);
            return render(props);
          }
        } else {
          console.log(`ProtectedRoute (${path}): Redirecting to authentication page`);
          return (
            <Redirect
              to={{
                pathname: authenticationPage,
                state: { from: props.location.pathname }
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
